import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BrandMark } from "../components/Brand";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LayoutGrid, Loader2, CheckCircle2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { HomeNetwork } from "../components/HomeNetwork";

const HIGHLIGHTS = [
  "Müşteri & firma yönetimi, hedef/gerçekleşen ciro takibi",
  "Kargo alımı, TIR / hat yükleme ve operasyon planlama",
  "İl/ilçe raporları ve canlı Türkiye haritası",
  "Tedarikçi, muhasebe (cari ekstre) ve iş listesi",
];

const SecretInput = ({ testId, value, onChange, placeholder, autoComplete }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input data-testid={testId} type={show ? "text" : "password"} value={value} onChange={onChange} placeholder={placeholder} autoComplete={autoComplete} className="h-11 border-slate-700 bg-slate-800 pr-11 text-slate-100" required />
      <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow((v) => !v)} title={show ? "GİZLE" : "GÖSTER"} className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-slate-400 hover:text-white">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};

const RegisterBox = ({ onDone }) => {
  const [f, setF] = useState({ name: "", tel: "", email: "", username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/public/home/register`, { data: f }); toast.success("ÜYELİĞİNİZ OLUŞTU — GİRİŞ YAPIN, 5 KREDİ HEDİYE"); onDone(f.username); }
    catch (e) { toast.error(e.response?.data?.detail || "KAYIT HATASI"); } finally { setBusy(false); }
  };
  const I = (k, l, t = "text") => (
    <div className="space-y-1"><Label className="text-slate-200">{l}</Label>
      <Input data-testid={`reg-${k}`} type={t} value={f[k]} onChange={(e) => setF({ ...f, [k]: k === "name" ? e.target.value.toLocaleUpperCase("tr-TR") : e.target.value })} className="h-10 border-slate-700 bg-slate-800 text-slate-100" /></div>
  );
  return (
    <div data-testid="register-box" className="space-y-3">
      {I("name", "AD SOYAD / FİRMA")}{I("tel", "TELEFON", "tel")}{I("email", "E-POSTA (İSTEĞE BAĞLI)", "email")}{I("username", "KULLANICI ADI")}{I("password", "ŞİFRE (EN AZ 4)", "password")}
      <Button type="button" data-testid="reg-submit" onClick={go} disabled={busy} className="h-11 w-full bg-emerald-600 text-base font-semibold text-white hover:bg-emerald-500">{busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "ÜYE OL — 5 KREDİ HEDİYE"}</Button>
    </div>
  );
};

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const saved = JSON.parse(localStorage.getItem("mwcrm_remember") || "null");
  const [remember, setRemember] = useState(!!saved);
  const [firm, setFirm] = useState(() => new URLSearchParams(window.location.search).get("firma") || saved?.firm || "");
  const [brand, setBrand] = useState(null);
  const [home, setHome] = useState(null);
  useEffect(() => {
    const f = firm.trim();
    if (f.length < 2) { setBrand(null); return; }
    const t = setTimeout(() => api.get("/public/brand", { params: { firma: f }, silent: true }).then((r) => setBrand(r.data?.name ? r.data : null)).catch(() => setBrand(null)), 350);
    return () => clearTimeout(t);
  }, [firm]);
  const [identifier, setIdentifier] = useState(saved?.user || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("staff");
  const [ptok, setPtok] = useState(() => localStorage.getItem("mw_home_token") || "");
  const [pname, setPname] = useState(() => localStorage.getItem("mw_home_name") || "");
  const portalLogin = async () => {
    const r = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/public/portal-login`, { data: { username: identifier, password, firma: (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/home`)).data.firma } });
    localStorage.setItem("mw_home_token", r.data.token); localStorage.setItem("mw_home_name", r.data.name);
    setPtok(r.data.token); setPname(r.data.name); setPassword("");
    toast.success(`HOŞ GELDİNİZ ${r.data.name}`);
  };
  const portalLogout = () => { localStorage.removeItem("mw_home_token"); localStorage.removeItem("mw_home_name"); setPtok(""); setPname(""); };


  const submit = async (e) => {
    if (remember) localStorage.setItem("mwcrm_remember", JSON.stringify({ firm: firm.trim(), user: identifier.trim() }));
    else localStorage.removeItem("mwcrm_remember");
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "portal") { await portalLogin(); return; }
      await login(identifier, password, firm);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "GİRİŞ BAŞARISIZ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-950 lg:h-screen lg:flex-row">
      <div className="order-2 flex-1 overflow-y-auto border-slate-800 lg:order-1 lg:border-r" data-testid="login-promo">
        <div className="sticky top-0 z-[600] flex items-center gap-3 border-b border-slate-800 bg-slate-950/90 px-5 py-3 backdrop-blur">
          {(brand || home)?.name ? <BrandMark brand={brand || home} size={40} /> : (
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600"><LayoutGrid className="h-5 w-5 text-white" /></div>)}
          <span data-testid="login-brand-name" className="mw-brandname font-head text-xl font-extrabold">{(brand || home)?.name || "MWCRMPRO"}</span>
          <span className="ml-2 hidden rounded-full bg-blue-600 px-3 py-1 text-xs font-bold tracking-wide md:inline" style={{ color: "#fff" }}>TÜRKİYE HİZMET & LOJİSTİK AĞI</span>
        </div>
        <div className="space-y-3 p-4 lg:p-5">
          <div className="mw-hero rounded-2xl bg-gradient-to-br from-blue-600 via-indigo-700 to-blue-900 p-5">
            <div className="font-head text-2xl font-extrabold text-white sm:text-3xl">Gönderinize uygun hizmet ağını saniyeler içinde bulun</div>
            <div className="mt-1 text-sm text-blue-100">Haritada tüm hizmet ağını ücretsiz görün, fiyat talebi bırakın, canlı yük ilanlarından yararlanın.</div>
            <ul className="mt-3 grid gap-1.5 sm:grid-cols-2">
              {HIGHLIGHTS.map((h) => <li key={h} className="flex items-start gap-2 text-xs text-blue-50"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-blue-200" /> {h}</li>)}
            </ul>
          </div>
          <HomeNetwork token={ptok} onBrand={setHome} onNeedLogin={() => { setMode("portal"); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
          <div className="pb-4 text-center text-xs text-slate-300">© {new Date().getFullYear()} {brand?.hide_mw ? brand.name : brand?.name ? `${brand.name} · MWCRMPRO` : "MWCRMPRO"}</div>
        </div>
      </div>

      <div className="order-1 flex w-full items-center justify-center p-6 lg:order-2 lg:w-[440px] lg:overflow-y-auto">
        <form onSubmit={submit} className="mw-fade-up w-full max-w-sm space-y-6">
          <div className="space-y-2 text-center lg:hidden">
            <div className="mx-auto flex w-fit">{brand?.name ? <BrandMark brand={brand} size={56} /> : (
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600">
              <LayoutGrid className="h-6 w-6 text-white" />
            </div>)}</div>
            <div className="font-head text-2xl font-extrabold text-white">{brand?.name || "MWCRMPRO"}</div>
          </div>
          {brand?.logo_url && (
            <div data-testid="login-firm-logo" className="hidden items-center gap-3 rounded-xl border border-slate-800 bg-slate-900/70 p-3 lg:flex">
              <BrandMark brand={brand} size={48} />
              <div className="min-w-0"><div className="truncate font-head text-lg font-bold text-white">{brand.name}</div><div className="text-[11px] text-slate-400">FİRMA GİRİŞİ</div></div>
            </div>
          )}
          <div data-testid="login-mode" className="grid grid-cols-3 gap-1 rounded-xl bg-slate-900 p-1">
            {[["staff", "PERSONEL / DEPO"], ["portal", "MÜŞTERİ GİRİŞİ"], ["register", "ÜYE OL"]].map(([k, l]) => <button type="button" key={k} data-testid={`login-mode-${k}`} onClick={() => setMode(k)} className={`rounded-lg py-2 text-xs font-bold transition-colors ${mode === k ? "bg-blue-600 text-white" : "text-slate-300 hover:text-white"}`}>{l}</button>)}
          </div>
          <div>
            <h2 className="font-head text-2xl font-bold text-white">{mode === "register" ? "ÜCRETSİZ ÜYE OL" : mode === "portal" ? "MÜŞTERİ GİRİŞİ" : "GİRİŞ YAP"}</h2>
            <p className="mt-1 text-sm text-slate-300">{mode === "register" ? "Üye olun, ilk girişte 5 kredi hediye ve fiyatlarda %10 indirim kazanın" : mode === "portal" ? "Hizmet ağına ulaşmak için giriş yapın — ilk girişte 5 kredi hediye" : "Hesabınıza erişmek için giriş yapın"}</p>
          </div>
          {mode === "portal" && ptok && (
            <div data-testid="portal-logged" className="flex items-center gap-2 rounded-xl border border-emerald-700 bg-emerald-500/10 p-3 text-sm text-emerald-300">
              <CheckCircle2 className="h-4 w-4" /> {pname} OLARAK GİRİŞ YAPILDI
              <button type="button" data-testid="portal-logout" onClick={portalLogout} className="ml-auto rounded bg-slate-800 px-2 py-1 text-xs text-white">ÇIKIŞ</button>
            </div>
          )}

          {mode === "register" && <RegisterBox onDone={(u) => { setIdentifier(u); setMode("portal"); }} />}
          {mode !== "register" && !(mode === "portal" && ptok) && <>
          {mode === "staff" && <div className="space-y-2">
            <Label className="text-slate-300">FİRMA</Label>
            <Input
              data-testid="login-firm-input"
              value={firm}
              onChange={(e) => setFirm(e.target.value)}
              placeholder="FİRMA ADINIZ"
              className="h-11 border-slate-700 bg-slate-800 text-slate-100"
            />
          </div>}
          <div className="space-y-2">
            <Label className="text-slate-300">KULLANICI ADI</Label>
            <SecretInput testId="login-username-input" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="••••••••" autoComplete="username" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">ŞİFRE</Label>
            <SecretInput testId="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" />
          </div>

          <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-300">
            <input data-testid="login-remember-checkbox" type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="h-4 w-4 accent-blue-600" />
            BENİ HATIRLA
          </label>

          <Button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="h-11 w-full bg-blue-600 text-base font-semibold text-white hover:bg-blue-700"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "GİRİŞ YAP"}
          </Button>
          </>}

          <div className="grid grid-cols-2 gap-2">
            {mode !== "register" && <button type="button" data-testid="login-go-register" onClick={() => setMode("register")} className="rounded-lg border border-emerald-600 py-2.5 text-xs font-bold text-emerald-300 hover:bg-emerald-600/10">MÜŞTERİ ÜYE OL</button>}
            <a data-testid="login-carrier-register" href={`/nakliyeci-kayit/${encodeURIComponent(home?.firma || home?.name || "")}`} className={`rounded-lg border border-orange-500 py-2.5 text-center text-xs font-bold text-orange-300 hover:bg-orange-500/10 ${mode === "register" ? "col-span-2" : ""}`}>NAKLİYECİ KAYIT</a>
          </div>
          <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-3 text-center text-xs text-slate-400">
          <p className="text-center text-xs text-slate-300">
            © {new Date().getFullYear()} {brand?.hide_mw ? brand.name : "MWCRMPRO"}
          </p>
          </div>
        </form>
      </div>
    </div>
  );
}
